import React, { Component } from 'react';
import PropTypes from 'prop-types';
import memoize from 'memoize-one';
import { Row } from 'react-flexbox-grid';
import {
  Section,
  Link,
  Button,
  Paragraph,
  LoadMorePagination,
} from 'components';
import { SinglePostTile } from '..';
import './PostList.scss';

class PostList extends Component {
  filterPosts = memoize((_data, filters, filtersActive) =>
    _data.filter(item => {
      if (!filtersActive) {
        return true;
      }

      const postCategory = filters.find(
        filter => filter.name === item.node.frontmatter.settings.category,
      );
      return postCategory && postCategory.isActive;
    }),
  );

  getCalculatedPosts = () => {
    const { posts, filters, filtersActive } = this.props;

    return this.filterPosts(posts, filters, filtersActive);
  };

  renderPosts = posts => {
    const { contributors, toggleFilter } = this.props;

    return posts.map(post => (
      <SinglePostTile
        key={`blog-post-${post.node.frontmatter.title}`}
        post={post}
        contributors={contributors}
        toggleFilter={toggleFilter}
      />
    ));
  };

  renderPostRows = filtered =>
    filtered.length > 0 ? (
      <Row className={'no-gap post-list__row'}>
        {this.renderPosts(filtered)}
      </Row>
    ) : (
      <Paragraph>Articles in this category will appear soon.</Paragraph>
    );

  checkResults(newFilter, navigatePage) {
    const { toggleFilter } = this.props;

    navigatePage(1);

    toggleFilter(newFilter.name);
  }

  renderPostFilters = navigatePage => {
    const { filters } = this.props;

    return filters.map(filter => (
      <button
        key={`filter-${filter.name}`}
        type="button"
        className={`post-list__filter-button ${filter.isActive &&
          'post-list__filter-button--active'}`}
        onClick={() => {
          this.checkResults(filter, navigatePage);
        }}
      >
        {filter.name}
      </button>
    ));
  };

  render() {
    return (
      <Section id={'blog-post-list'} additionalClass={'post-list'}>
        <LoadMorePagination
          index="page"
          loadCount={6}
          data={this.getCalculatedPosts()}
        >
          {({ items, loadMore, navigatePage }) => (
            <>
              <div className={'post-list__filters-list'}>
                {this.renderPostFilters(navigatePage)}
              </div>
              <div className={'post-list__grid'}>
                {this.renderPostRows(items)}
              </div>
              <div className={'post-list__button-wrapper'}>
                {loadMore && (
                  <div className={'post-list__button'}>
                    <Button
                      tag={Link}
                      to={loadMore.path}
                      transparent
                      color={'black'}
                      onClick={loadMore.action}
                    >
                      Load more
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}
        </LoadMorePagination>
      </Section>
    );
  }
}

PostList.propTypes = {
  posts: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  filtersActive: PropTypes.bool.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  contributors: PropTypes.array.isRequired,
};

export default PostList;
